import formatDate, { formatDateFromNow } from "../../helpers/formatDate";

export default function StaticTimeAgo({ date }: { date: string }) {
  return (
    <time
      className="timeago created"
      dateTime={date}
      title={formatDate(new Date(date), "dd.MM.yyyy HH:mm")}
    >
      <span className="print:hidden">
        {formatDateFromNow(new Date(date), {
          addSuffix: true,
        })}
      </span>
      {/* Print shows the exact timestamp — the relative time carries it only
          in the hover title, which does not exist on paper (tixxt/core#181) */}
      <span className="hidden print:inline">
        {formatDate(new Date(date), "dd.MM.yyyy HH:mm")}
      </span>
    </time>
  );
}
